import React, { useState } from 'react';
import { FiPackage, FiTruck, FiCheckCircle, FiClock, FiMapPin, FiSearch } from 'react-icons/fi';
import './TrackOrder.css';

const TrackOrder = () => {
  const [orderNumber, setOrderNumber] = useState('');
  const [email, setEmail] = useState('');
  const [isTracking, setIsTracking] = useState(false);
  const [orderFound, setOrderFound] = useState(null);

  const handleTrackOrder = (e) => {
    e.preventDefault();
    setIsTracking(true);
    
    // Simulate API call
    setTimeout(() => {
      // Mock order data
      setOrderFound({
        orderNumber: 'BAS-2026-001',
        status: 'shipped',
        date: 'Feb 10, 2026',
        estimatedDelivery: 'Feb 15, 2026',
        items: [
          { name: 'Runner Elite Sneakers', quantity: 1, price: 890 },
          { name: 'Aviator Sunglasses', quantity: 1, price: 420 }
        ],
        total: 1310,
        trackingHistory: [
          { status: 'Order Placed', date: 'Feb 10, 2026', time: '10:30 AM', completed: true },
          { status: 'Order Confirmed', date: 'Feb 10, 2026', time: '11:45 AM', completed: true },
          { status: 'Processing', date: 'Feb 11, 2026', time: '09:20 AM', completed: true },
          { status: 'Shipped', date: 'Feb 12, 2026', time: '02:15 PM', completed: true },
          { status: 'Out for Delivery', date: 'Feb 15, 2026', time: '08:00 AM', completed: false },
          { status: 'Delivered', date: 'Estimated', time: 'Feb 15, 2026', completed: false }
        ]
      });
      setIsTracking(false);
    }, 1500);
  };

  return (
    <div className="track-order-page">
      {/* Hero Section */}
      <section className="track-hero">
        <div className="container">
          <h1 className="track-hero-title">Track Your Order</h1>
          <p className="track-hero-description">
            Enter your order number and email to check your order status and tracking information.
          </p>
        </div>
      </section>

      {/* Track Order Form */}
      <section className="track-form-section">
        <div className="container">
          <div className="track-form-container">
            <form onSubmit={handleTrackOrder} className="track-form">
              <div className="form-row">
                <div className="form-group">
                  <label htmlFor="orderNumber">Order Number</label>
                  <input
                    type="text"
                    id="orderNumber"
                    placeholder="e.g., BAS-2026-001"
                    value={orderNumber}
                    onChange={(e) => setOrderNumber(e.target.value)}
                    required
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="email">Email Address</label>
                  <input
                    type="email"
                    id="email"
                    placeholder="your@email.com"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                  />
                </div>
              </div>
              <button type="submit" className="track-btn" disabled={isTracking}>
                {isTracking ? (
                  <>
                    <span className="spinner"></span>
                    TRACKING...
                  </>
                ) : (
                  <>
                    <FiSearch />
                    TRACK ORDER
                  </>
                )}
              </button>
            </form>

            {orderFound && (
              <div className="track-results">
                <div className="order-header">
                  <div>
                    <h3>Order #{orderFound.orderNumber}</h3>
                    <p>Placed on {orderFound.date}</p>
                  </div>
                  <div className="order-status">
                    <span className={`status-badge ${orderFound.status}`}>
                      {orderFound.status.toUpperCase()}
                    </span>
                  </div>
                </div>

                {/* Tracking Timeline */}
                <div className="tracking-timeline">
                  {orderFound.trackingHistory.map((step, index) => (
                    <div key={index} className={`timeline-step ${step.completed ? 'completed' : ''}`}>
                      <div className="step-icon">
                        {index === 0 && <FiPackage />}
                        {index === 1 && <FiCheckCircle />}
                        {index === 2 && <FiClock />}
                        {index === 3 && <FiTruck />}
                        {index === 4 && <FiMapPin />}
                        {index === 5 && <FiCheckCircle />}
                      </div>
                      <div className="step-content">
                        <h4>{step.status}</h4>
                        <p>{step.date} • {step.time}</p>
                      </div>
                      {index < orderFound.trackingHistory.length - 1 && (
                        <div className={`timeline-connector ${step.completed ? 'completed' : ''}`}></div>
                      )}
                    </div>
                  ))}
                </div>

                {/* Order Summary */}
                <div className="order-summary">
                  <h4>Order Summary</h4>
                  {orderFound.items.map((item, index) => (
                    <div key={index} className="summary-item">
                      <span>{item.name} × {item.quantity}</span>
                      <span>${item.price.toLocaleString()}</span>
                    </div>
                  ))}
                  <div className="summary-total">
                    <span>Total</span>
                    <span>${orderFound.total.toLocaleString()}</span>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </section>

      {/* Need Help Section */}
      <section className="track-help-section">
        <div className="container">
          <div className="help-grid">
            <div className="help-card">
              <h3>Need Assistance?</h3>
              <p>Our customer service team is here to help with any questions about your order.</p>
              <a href="/contact" className="help-link">Contact Us →</a>
            </div>
            <div className="help-card">
              <h3>Shipping Information</h3>
              <p>Learn about our shipping methods, delivery times, and tracking.</p>
              <a href="/shipping" className="help-link">Shipping Info →</a>
            </div>
            <div className="help-card">
              <h3>Returns & Exchanges</h3>
              <p>Everything you need to know about our return policy and process.</p>
              <a href="/returns" className="help-link">Return Policy →</a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default TrackOrder;